import React from "react"

interface UseHowItWorksNavigationParams {
  isMobile: boolean
  scrollRef: React.MutableRefObject<HTMLDivElement | null>
  stepRefs: React.MutableRefObject<(HTMLDivElement | null)[]>
  setCurrent: React.Dispatch<React.SetStateAction<number>>
  setIsManual: React.Dispatch<React.SetStateAction<boolean>>
  threshold?: number
  headerOffset?: number
}

const useHowItWorksNavigation = ({
  isMobile,
  scrollRef,
  stepRefs,
  setCurrent,
  setIsManual,
  threshold = 800,
  headerOffset = 120,
}: UseHowItWorksNavigationParams) => {
  return React.useCallback(
    (index: number) => {
      setCurrent(index)

      if (isMobile) {
        const element = stepRefs.current[index]

        if (!element) return

        const elementTop = element.getBoundingClientRect().top + window.scrollY

        window.scrollTo({
          top: elementTop - headerOffset,
          behavior: "smooth",
        })

        return
      }

      const container = scrollRef.current

      if (!container) return

      setIsManual(true)

      const pageOffsetTop = container.getBoundingClientRect().top + window.scrollY
      const scrollTo = pageOffsetTop + threshold * index

      window.scrollTo({
        top: scrollTo,
        behavior: "smooth",
      })

      window.setTimeout(() => setIsManual(false), 1000)
    },
    [headerOffset, isMobile, scrollRef, setCurrent, setIsManual, stepRefs, threshold]
  )
}

export default useHowItWorksNavigation
